import React, { useCallback, useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useMediaQuery } from '@mui/material';
import { LogoutOutlined, AccountCircleOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { ProfileImage } from '../Drawer.styles';
import { FooterWrapper, DividerStyled, ProfileContainerBox, ProfileImageBox, ProfileWrapper, LogoutImageWrapper, ProfileIconWrapper } from './DrawerFooter.styles';
import { useGetLoggenInUserData } from '../../../../queries/user-query';
import { LoggedInUser, RoutesEnum, ScreenSize } from '../../../../@types';
import { SAMPLE_LOGIN_USER } from '../../../../constants/user.constant';
import { DrawerFooterProps } from './DrawerFooter.props';

export const DrawerFooter: React.FC<DrawerFooterProps> = ({ toggleDrawer }) => {
  const { logout } = useAuth0();
  const navigate = useNavigate();
  const [userData, setUserData] = useState<LoggedInUser>(SAMPLE_LOGIN_USER);
  const isMobileView = useMediaQuery(ScreenSize.MOBILE);

  const getLoggenInUserData = useGetLoggenInUserData();

  useEffect(() => {
    getLoggenInUserData.data && setUserData({
      ...userData,
      userName: getLoggenInUserData.data.userName,
      profilePic: getLoggenInUserData.data.profilePic
    });
  }, [getLoggenInUserData.data]);

  const onLogOut = useCallback(() => {
    localStorage.clear();
    logout({ logoutParams: { returnTo: window.location.origin } });
  }, [logout]);

  return (
    <FooterWrapper>
      <DividerStyled />
      <ProfileContainerBox>
        <ProfileImageBox>
          <ProfileIconWrapper
            onClick={() => {
              navigate(RoutesEnum.ProfileRoute, { replace: true });
              isMobileView && toggleDrawer();
            }}
          >
            {(userData.profilePic && userData.profilePic !== '') ? (
              <ProfileImage src={userData.profilePic} />
            ):(
              <AccountCircleOutlined fontSize="large"/>
            )}
          </ProfileIconWrapper>
          <ProfileWrapper>
            {userData.userName}
          </ProfileWrapper>
        </ProfileImageBox>
        <LogoutImageWrapper onClick={onLogOut}>
          <LogoutOutlined />
        </LogoutImageWrapper>
      </ProfileContainerBox>
    </FooterWrapper>
  );
};
